import translate from "@/i18n/translate";
import React, { Fragment, useReducer } from "react";
import { WmButton } from "@watermarkinsights/ripple-react";
import { ProgramAndPageViews } from "./TopProgramsByCatalog";
import { openFlyout } from "../../../static/js/commons";
import AllProgramsFlyout from "./AllProgramsFlyout";

interface TopProgramsTableState {
  isDrilldownOpen: boolean;
}
interface TopProgramsTableAction {
  type: string;
  isDrilldownOpen: boolean;
}

const topProgramsTableDefaultAction = {
  type: "",
  isDrilldownOpen: false
};

export interface TopProgramsTableProps {
  programDetails: ProgramAndPageViews[];
}

const initialState = {
  isDrilldownOpen: false
};

const reducer = (
  state: TopProgramsTableState,
  action: TopProgramsTableAction
) => {
  switch (action.type) {
    case "ToggleDrilldown":
      return { ...state, isDrilldownOpen: !state.isDrilldownOpen };
    default:
      return state;
  }
};

export default function TopProgramsTable({
  programDetails
}: TopProgramsTableProps): JSX.Element {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setIsDrilldownOpen = () => {
    dispatch({ ...topProgramsTableDefaultAction, type: "ToggleDrilldown" });
  };

  const openDrilldownView = () => {
    setTimeout(
      () =>
        openFlyout(
          "drill-down-view",
          "course-charts",
          "all-programs-close-btn"
        ),
      400
    );
    setIsDrilldownOpen();
  };

  return (
    <>
      <div
        id="org-table-catalog"
        className={programDetails.length <= 10 ? "catalog-table" : ""}
      >
        <Table>
          <TableHeader
            columns={[
              translate("app.strategy.topProgramsByCatalog.program"),
              translate("app.strategy.topProgramsByCatalog.pageViews")
            ]}
          />
          <TableBody programDetails={programDetails} />
        </Table>
      </div>
      <div className="view-more">
        {programDetails.length > 10 && (
          <WmButton buttonType="textonly" onClick={() => openDrilldownView()}>
            <span className="read-more">
              {translate("app.strategy.topProgramsByCatalog.viewMore")}
            </span>
          </WmButton>
        )}
      </div>
      {state.isDrilldownOpen ? (
        <Fragment>
          <div
            className="sr-only"
            id="course-dialog-wrapper-flyout-top"
            tabIndex={0}
          ></div>
          <AllProgramsFlyout
            setIsDrilldownOpen={setIsDrilldownOpen}
            programDetails={programDetails}
          ></AllProgramsFlyout>
          <div
            className="sr-only"
            id="course-dialog-wrapper-flyout-top"
            tabIndex={0}
          ></div>
        </Fragment>
      ) : (
        ""
      )}
      <div
        className="sr-only"
        id="course-dialog-wrapper-flyout-bottom"
        tabIndex={0}
      ></div>
    </>
  );
}

const TableBody = ({ programDetails }: TopProgramsTableProps) => {
  return (
    <tbody className="databody">
      {programDetails
        .slice(0, 10)
        .map((programDetail: ProgramAndPageViews, index: number) => {
          return (
            <tr
              className="datarow"
              key={`${index}-${programDetail.programName}`}
            >
              <td className="datacell">
                <div>{programDetail.programName}</div>
              </td>
              <td className="datacell">{programDetail.pageViews}</td>
            </tr>
          );
        })}
    </tbody>
  );
};
const Table = (props: any) => {
  return <table className="data-table -shadow">{props.children}</table>;
};

export const TableHeader = (props: any) => {
  return (
    <thead className="dataheader">
      <tr className="dataheaderrow">
        {props.columns.map((column: string, index: number) => {
          return (
            <th
              className="dataheadercell"
              data-th={column}
              key={`column-${index}`}
            >
              {column}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};
